import React from "react";
import { useNavigate } from "react-router-dom";

const ShopStripeCancelledPage = () => {
    const navigate = useNavigate();

    return (
        <div className="container mx-auto max-w-lg p-6 bg-white rounded-lg shadow-md text-center">
            <h1 className="text-xl font-bold text-pegasusPurple mb-4">
                Stripe-Zahlung fehlgeschlagen!
            </h1>
            <p className="text-gray-600 mb-6">
                Die Stripe-Zahlung wurde abgebrochen. Die gewünschten Artikel wurden nicht
                gekauft. Dein Warenkorb ist noch vorhanden, du kannst es erneut versuchen.
            </p>
            <button
                onClick={() => navigate('/cart')}
                className="bg-pegasusPurple text-white py-2 px-6 rounded-lg font-semibold hover:bg-pegasusPurpleHover"
            >
                ZURÜCK ZUM WARENKORB
            </button>
        </div>
    );
};

export default ShopStripeCancelledPage;
